export default "__VITE_ASSET__X36tGdTe__"